module.exports = __webpack_public_path__ + "img/Music_bg.a8bead09.png";